import {http} from "./httpClient";

export const getCategories = () => http.get("legacy", "/categories");

export const getTrees = () => http.get("legacy", "/trees");

export const getColors = () => http.get("legacy", "/colors");

export const getSets = (categoryId) =>
	http.post("legacy", "/set", {data: {categoryId}});

export const getFurnitures = (setId) =>
	http.post("legacy", "/furnitures", {data: {setId}});
